import type { UserData } from '~/types/user';

export function getUserInitials(user?: Pick<UserData, 'name'>): string | undefined {
  if (!user?.name || user.name.length === 0) {
    return undefined;
  }

  const [name, surname] = user.name.split(' ');

  if (!name?.length) {
    return undefined;
  }

  if (!surname?.length) {
    return name[0].toUpperCase();
  }

  return `${name[0].toUpperCase()}${surname[0].toUpperCase()}`;
}
